import { useCallback } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
/**
 * Batches all state updates in the provided handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useBatchedHandler(callback) {
    const batchedCallback = useCallback(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>unstable_batchedUpdates(()=>callback === null || callback === void 0 ? void 0 : callback(...args)), [
        callback
    ]);
    if (callback) {
        return batchedCallback;
    }
}

//# sourceMappingURL=useBatchedHandler.js.map